import React, { useEffect, useState, useContext, useCallback } from 'react';
import classNames from 'classnames';

import { JOURNEY_STEPS, JOURNEY_STEPS_FOR_MULTI_SITE, PRODUCT_LIST, UNAUTH_DEDICATED_JOURNEY_STEPS } from '../../../common/constants/constants';
import { getFromSessionStorage, navigateTo, findParamFromUrl } from '../../../../common/utils/app.utils';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import {
  FEASIBILITY_STATUS,
  MODULE_ID,
  FEASIBILITY_RESPONSE,
  JOURNEY_STEPS_INDEX,
  UNAUTH_DEDICATED_STEPS_INDEX,
  DEDICATED_FEASIBILITY_RESPONSE
} from '../../../common/constants/constants';
import { PRODUCT_NAME, ROUTES, isBulkUpgrade } from '../../../../common/constants/app.constants';
import { redirectToTMO } from 'home/view/manage-feasibility/utils';
import SubHeader from '../../../../dedicated/components/subHeader/subHeader';
import config from '../../../../config/config';

import CustomModal from 'dedicated/components/customModal/customModal';

import { AppContext } from 'App';
import EmailProposal from '../email-proposal/email-proposal';
import AuthStepper from 'home/view/manage-feasibility/pages/LandingPage/AuthStepper';

import './steps.component.scss';
// import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';

const StepsHeader = (props) => {
  const partyId = findParamFromUrl('partyId', false);

  let history = useHistory();

  const { multiSiteFileUploadSuccess } = useContext(AppContext);

  let {
    userType,
    activeStepIndex,
    skipNetworkstatus,
    disabledChoosePlan,
    isdedicatedJourney,
    isUnAuthJourney,
    disabled,
    showFeasibilityStatus,
    hideBackBtn,
    isMultiSite = false,
    showCbftId = false,
    showEmailProposal,
    showTrackBtn,
    selectedPlan,
    orderDetail
  } = props;

  let feasibilityResponse = isdedicatedJourney ? getFromSessionStorage(MODULE_ID, DEDICATED_FEASIBILITY_RESPONSE) : getFromSessionStorage(MODULE_ID, FEASIBILITY_RESPONSE);

  let feasibilityStatus = feasibilityResponse && feasibilityResponse.feasibilityStatus;

  let [indexValue, setIndexValue] = useState(1);
  let [productName, setProductName] = useState('');
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);

  if (
    (!feasibilityStatus || feasibilityStatus) &&
    (showFeasibilityStatus === 'FEASIBLE' || showFeasibilityStatus !== 'MANUAL_INTERVENTION_REQUIRED') &&
    showFeasibilityStatus !== 'PENDING'
  ) {
    feasibilityStatus = FEASIBILITY_STATUS.FEASIBLE_HIGH_CONFIDENCE.key;
  }

  const isShiftingOrder = () => {
    return orderDetail?.orderType === 'CHANGE_ORDER' && orderDetail?.orderSubType === 'SHIFTING';
  };

  const changePage = (index) => {
    if (index === JOURNEY_STEPS_INDEX.CHECK_AVAILABLITY) {
      let redirectUrl = ROUTES.B2B_CHECK_FEASIBILITY;
      if (partyId) {
        redirectUrl = redirectUrl + '?partyId=' + partyId;
      }

      history.push(redirectUrl);
    } else if (index === JOURNEY_STEPS_INDEX.CHOOSE_PLAN) {
      let redirectUrl = ROUTES.B2B_CHOOSE_PLAN;
      if (partyId) {
        redirectUrl = redirectUrl + '?partyId=' + partyId;
      }

      history.push(redirectUrl);
    } else if (index === JOURNEY_STEPS_INDEX.BOOKING_SUMMARY) {
      let redirectUrl = ROUTES.B2B_SUMMARY;
      if (partyId) {
        redirectUrl = redirectUrl + '?partyId=' + partyId;
      }

      history.push(redirectUrl);
    } else if (index === 0) {
      navigateTo(config.selfcareBasePageUrl);
    }
  };

  const handleMultiSiteRedirect = (index) => {
    const activeStepIndex = index + 1 || indexValue;
    if (activeStepIndex === JOURNEY_STEPS_INDEX.CHECK_AVAILABLITY || activeStepIndex === JOURNEY_STEPS_INDEX.CHOOSE_PLAN) {
      let redirectUrl = isUnAuthJourney ? config.dedicatedhomePageUrl : config.selfcareBasePageUrl;

      navigateTo(redirectUrl);
    }
  };

  const changeDedicatedPage = (index) => {
    if (isMultiSite) {
      setIndexValue(index + 1);

      if (multiSiteFileUploadSuccess) {
        setShowConfirmationPopup(true);
      } else {
        handleMultiSiteRedirect(index);
      }
      // const activeStepIndex = index + 1;

      // if (
      //   activeStepIndex === JOURNEY_STEPS_INDEX.CHECK_AVAILABLITY ||
      //   activeStepIndex === JOURNEY_STEPS_INDEX.CHOOSE_PLAN
      // ) {
      //   let redirectUrl = isUnAuthJourney
      //     ? config.dedicatedhomePageUrl
      //     : config.selfcareBasePageUrl;

      //   navigateTo(redirectUrl);
      // }
    } else {
      if (index === JOURNEY_STEPS_INDEX.CHECK_AVAILABLITY) {
        let redirectUrl = ROUTES.DEDICATED_HOME;
        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }

        history.push(redirectUrl);
      } else if (index === JOURNEY_STEPS_INDEX.CHOOSE_PLAN) {
        let redirectUrl = ROUTES.DEDICATED_CHOOSE_PLAN;
        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }

        history.push(redirectUrl);
      } else if (index === JOURNEY_STEPS_INDEX.BOOKING_SUMMARY) {
        let redirectUrl = ROUTES.DEDICATED_CHOOSE_PLAN;
        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }

        history.push(redirectUrl);
      } else if (index === 0) {
        let url = isUnAuthJourney ? config.dedicatedhomePageUrl : config.selfcareBasePageUrl;
        navigateTo(url);
      }
    }
  };

  const handleClick = (index) => {
    if (isdedicatedJourney) {
      changeDedicatedPage(index);
    } else {
      changePage(index);
    }
  };

  const handleTrackBtnClick = () => {
    if (isdedicatedJourney && isMultiSite) {
      redirectToTMO();
    }
  };

  const journeySteps = !isMultiSite && isUnAuthJourney && isdedicatedJourney ? UNAUTH_DEDICATED_JOURNEY_STEPS : isMultiSite ? JOURNEY_STEPS_FOR_MULTI_SITE : JOURNEY_STEPS;

  useEffect(() => {
    const getProductName = () => {
      const getParams = queryString.parse(window && window.location.search);
      let productType = getParams && getParams.productType;
      if (!productType) {
        productType = getFromSessionStorage(MODULE_ID, PRODUCT_NAME);
      }
      const productList = isBulkUpgrade() ? PRODUCT_LIST.BULK_UPGRADE : PRODUCT_LIST;

      return productList[productType];
    };

    setProductName(getProductName());
  }, [isBulkUpgrade()]);

  // const journeySteps = isUnAuthJourney && isdedicatedJourney ? UNAUTH_DEDICATED_JOURNEY_STEPS : JOURNEY_STEPS;

  const renderStepper = useCallback(() => {
    // if (isOrderConfirmationUrl()) {
    //   return null;
    // }

    if (!isUnAuthJourney) {
      return <AuthStepper activeStep={activeStepIndex} />;
    }

    const ulClassNames = classNames({
      'steps steps_secondary': true,
      'fist-child-disabled': showFeasibilityStatus === 'FEASIBILITY_COMPLETED'
    });

    const getLiClassNames = (index) => {
      const activeStepGreaterThanIndex = activeStepIndex > index;
      const activeStepEqualIndex = activeStepIndex === index;
      const invalidActiveStep = !activeStepGreaterThanIndex || !activeStepEqualIndex;
      const disabledLink = (disabled && index === 1) || disabledChoosePlan;

      return classNames({
        visited: activeStepGreaterThanIndex,
        active: activeStepEqualIndex,
        'inside-content': invalidActiveStep,
        'disabled-link': disabledLink || invalidActiveStep
      });
    };

    return (
      <ul className={ulClassNames}>
        {activeStepIndex &&
          journeySteps.map((stepName, index) => {
            // index starting from 0 but we are showing it from 1
            index = index + 1;
            return (
              <li className={getLiClassNames(index)}>
                <div className="inside-content">
                  <span className="number">{index}</span>
                  <div className="step-text">{stepName}</div>
                </div>
              </li>
            );
          })}
      </ul>
    );
  }, [isUnAuthJourney, activeStepIndex]);

  const planStepsClassNames = classNames({
    'plan-steps': true,
    'auth-steps': !isUnAuthJourney,
    container: isShiftingOrder()
  });

  return (
    <React.Fragment>
      {showConfirmationPopup && (
        <CustomModal
          customPopupTitle="Go Back"
          customPopupMsg="All the data uploaded on the system through the CSV file will be removed if you go back. Are you sure you want to proceed?"
          submitCustomPopup={handleMultiSiteRedirect}
          closeCustomPopup={() => setShowConfirmationPopup(false)}
        />
      )}

      {activeStepIndex && (
        <SubHeader
          userType={userType}
          productName={productName}
          handleClick={handleClick}
          activeStepIndex={activeStepIndex}
          hideBackBtn={hideBackBtn}
          showTrackBtn={showTrackBtn}
          onTrackBtnClick={handleTrackBtnClick}
          isMultiSite={isMultiSite}
          isUnAuthJourney={isUnAuthJourney}
          orderDetail={orderDetail}
        />
      )}

      <div className={planStepsClassNames}>
        {renderStepper()}
        {!isShiftingOrder() && !skipNetworkstatus && (
          <React.Fragment>
            {activeStepIndex !== 1 ? (
              FEASIBILITY_STATUS.FEASIBLE_HIGH_CONFIDENCE.key === feasibilityStatus ? (
                <span className="network_type">{FEASIBILITY_STATUS.FEASIBLE_HIGH_CONFIDENCE.value}</span>
              ) : FEASIBILITY_STATUS.FEASIBLE_LOW_CONFIDENCE.key === feasibilityStatus || FEASIBILITY_STATUS.NOT_FEASIBLE_LOW_CONFIDENCE.key === feasibilityStatus ? (
                <span className="orangeshade network_type">{FEASIBILITY_STATUS.FEASIBLE_LOW_CONFIDENCE.value}</span>
              ) : (
                <span className="orangeshade network_type">{FEASIBILITY_STATUS.FEASIBLE_LOW_CONFIDENCE.value}</span>
              )
            ) : (
              ''
            )}
          </React.Fragment>
        )}
        {!isShiftingOrder() && showCbftId && !isMultiSite && isdedicatedJourney && feasibilityResponse && feasibilityResponse.cbftTaskId ? (
          <span
            className="text"
            style={{
              display: 'flex',
              fontWeight: '600',
              fontSize: '14px',
              lineHeight: '1.23',
              color: '#0c0f12',
              marginTop: '7px'
            }}
          >
            <strong>Manual Feasibility ID: {feasibilityResponse.cbftTaskId}</strong>
          </span>
        ) : null}
        {showEmailProposal ? <EmailProposal selectedPlan={selectedPlan} /> : ''}
      </div>
    </React.Fragment>
  );
};

export default StepsHeader;
